module.exports = __webpack_public_path__ + "img/right-grid.8a1c144a.png";